import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import classNames from 'classnames';
import { Text } from '@nerdwallet/currency';
import nds from '@nerdwallet/base-styles/classes';

const ReviewAnnotation = ({ data, config }) => {
  const path = get(config, 'review_path');
  const rating = get(data, path);

  return (
    <span className={classNames('review-annotation', nds('padding-top-2'))}>
      <a href={rating}>
        <Text size="small">NerdWallet rating</Text>
      </a>
    </span>
  );
};

ReviewAnnotation.propTypes = {
  data: PropTypes.object,
  config: PropTypes.shape({
    review_path: PropTypes.string,
  }),
};

ReviewAnnotation.displayName = 'ReviewAnnotation';

export default ReviewAnnotation;
